import styled from 'styled-components';

import { getVariant } from '@/themes/typographyUtilis';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 384px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 16px;
  padding: 28px;
  background: ${({ theme }) => theme.colors.modalBackground};
  text-align: center;
  gap: 20px;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.background.light};
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.primaryText};
  ${getVariant({ variant: 'subheadline1-medium' })};
`;

export const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.secondaryText};
  ${getVariant({ variant: 'body1-normal' })};
`;

export const Actions = styled.div`
  display: flex;
  width: 100%;
  padding-top: 4px;
  gap: 12px;

  > * {
    flex: 1;
  }
`;
